import React, { useRef, Fragment } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Icon, useOnScreen } from 'tmt-ui-kit';

import { mapIcon } from '~/utils/trip';
import GoogleMap, { OverlayView } from '~/components/GoogleMap';

const DefaultMapContainer = styled.div`
  width: 100%;
  height: 320px;
  @media(max-width: 700px) {
    height: 264px;
  }
`;

function fitBounds(trip, map) {
  if (!map) return;
  const ll = trip.custom_locations && trip.custom_locations.length > 0
    ? trip.custom_locations
    : trip.meeting_points;
  const locations = ll
    .filter(point => point.location && point.location.lat && point.location.lon)
    .map(
      point => new window.google.maps.LatLng(point.location.lat, point.location.lon)
    );
  const bounds = new window.google.maps.LatLngBounds();
  locations.map(location => bounds.extend(location));
  if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
    const extendPoint1 = new window.google.maps.LatLng(
      bounds.getNorthEast().lat() + 0.001,
      bounds.getNorthEast().lng() + 0.001
    );
    const extendPoint2 = new window.google.maps.LatLng(
      bounds.getNorthEast().lat() - 0.001,
      bounds.getNorthEast().lng() - 0.001
    );
    bounds.extend(extendPoint1);
    bounds.extend(extendPoint2);
  }
  map.fitBounds(bounds);
}

const PinSquare = styled.div`
  background-color: ${props => props.theme.white};
  width: 32px;
  height: 32px;
  box-sizing: border-box;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  font-size: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Arrow = styled.div`
  z-index: 2;
  position: absolute;
  left: 14px;
  bottom: -3px;
  width: 4px;
  height: 4px;
  border-width:1px;
  border-style:solid;
  border-color:transparent rgba(0, 0, 0, 0.1) rgba(0, 0, 0, 0.1) transparent;
  transform:rotate(45deg);
  background-color: ${props => props.theme.white};
`;

const InsideTriangle = styled.div`
  z-index: 2;
  position: absolute;
  bottom: -3px;
  left: 12px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 4px 0 4px;
  border-color: ${props => props.theme.white} transparent transparent transparent;
`;

const MeetingPointsMap = props => {
  const { trip } = props;
  const hasCustomLocations = trip && trip.custom_locations && trip.custom_locations.length > 0;
  let markers = [];

  if (hasCustomLocations) {
    markers = trip && trip.custom_locations.filter(loc => (
      loc.location && loc.location.lat && loc.location.lon
    ));
  } else {
    markers = trip && trip.meeting_points.filter(point => (
      point.location && point.location.lat && point.location.lon
    ));
  }
  if (markers.length <= 0) return null;

  const seenRef = useRef(null);
  const isSeen = useOnScreen(seenRef, '100px', true);
  return (
    <Fragment>
      <div ref={seenRef} />
      {isSeen && (
        <GoogleMap
          fitBounds={map => fitBounds(trip, map)}
          mapContainer={<DefaultMapContainer />}
        >
          {markers.map((marker, index) => (
            <OverlayView
              key={`${index}_${marker.icon_name}`}
              position={{ lat: marker.location.lat, lng: marker.location.lon }}
            >
              <div>
                <PinSquare style={{ backgroundColor: '#ffffff' }}>
                  <Icon name={hasCustomLocations ? 'map-pin' : mapIcon(marker.icon_name)} />
                </PinSquare>
                <InsideTriangle />
                <Arrow style={{ backgroundColor: '#ffffff' }} />
              </div>
            </OverlayView>
          ))}
        </GoogleMap>
      )}
    </Fragment>
  );
};

MeetingPointsMap.propTypes = {
  trip: PropTypes.object,
};

export default MeetingPointsMap;
